export const DEMO_MODE = true;

const DEMO_TYPES = ["AUTOMOBIL", "SKUTER", "BICIKL", "STAN"];

const CAR_IMAGES = {
  "VW Golf": "https://www.shutterstock.com/image-photo/cincinnati-ohio-usa-december-18-600w-2621150159.jpg",
  "Opel Corsa": "https://media.istockphoto.com/id/1348943923/photo/opel-corsa.webp?s=2048x2048&w=is&k=20&c=sooX9wUeCQNr6RsxwPoQmMD9tBCbmFjgzLK4otFuLOc=",
  "Renault Clio": "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?auto=format&fit=crop&w=1200&q=80",
  "Skoda Octavia": "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?auto=format&fit=crop&w=1200&q=80",
  "Fiat 500": "https://media.gettyimages.com/id/1306542752/photo/electric-car-fiat-500e-on-a-street.jpg?s=1024x1024&w=gi&k=20&c=sJdOFfo0uaWQJrhfeEpIIKcmAIz4oMHaw9vKvw1iLB8=",
};

const SCOOTER_IMAGE = "https://media.istockphoto.com/id/1818435415/photo/scooter-blue-isolated-on-white-background.jpg?s=2048x2048&w=is&k=20&c=0PeO_WWenbAnPy0ZWzkvhXfPC49DCnaMyFeAFvalMSM=";
const BICYCLE_IMAGE = "https://media.istockphoto.com/id/1344641295/photo/new-mountain-bicycle-with-29-inches-wheels-and-blue-frame-isolated-on-white-background.jpg?s=2048x2048&w=is&k=20&c=7iRmdhzSg24uDTq_bCBrd3g8W8A20HrcenLWQ5q_5U0=";
const APARTMENT_IMAGE = "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1200&q=80";

const demoNamesByType = {
  AUTOMOBIL: ["VW Golf", "Skoda Octavia", "Opel Corsa", "Renault Clio", "Fiat 500"],
  SKUTER: ["Piaggio Liberty", "Yamaha NMAX", "Honda PCX", "Kymco Agility", "Vespa Primavera"],
  BICIKL: ["Trek FX 3", "Giant Escape", "Cube Touring", "Scott Sub", "Specialized Sirrus"],
  STAN: ["Stan Centar", "Stan Luka", "Stan Park", "Stan Old Town", "Stan Panorama"],
};

function atTime(baseDate, daysOffset, hour, minute) {
  const date = new Date(baseDate);
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

function createCars() {
  let idx = 1;
  const cars = [];

  DEMO_TYPES.forEach((type) => {
    demoNamesByType[type].forEach((name, itemIdx) => {
      const id = `demo-${type.toLowerCase()}-${itemIdx + 1}`;
      cars.push({
        text: name,
        id,
        desc: `${type} ${itemIdx + 1}`,
        vrsta: type,
        imgLink:
          type === "SKUTER"
            ? SCOOTER_IMAGE
            : type === "BICIKL"
              ? BICYCLE_IMAGE
              : type === "STAN"
                ? APARTMENT_IMAGE
              : CAR_IMAGES[name] || "",
        excelLink: "nema",
        sifraNajma: `D-${String(idx).padStart(3, "0")}`,
        longterm: false,
        docId: id,
      });
      idx += 1;
    });
  });

  return cars;
}

function createEvents(cars) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const baseEvents = [
    // Zavrsava danas
    { carIndex: 0, start: [-3, 9, 0], end: [0, 11, 0], status: "Unajmu", subject: "Ivan Horvat" },
    { carIndex: 5, start: [-2, 14, 0], end: [0, 16, 0], status: "Unajmu", subject: "Marta K." },
    // Krece danas
    { carIndex: 1, start: [0, 12, 0], end: [2, 10, 0], status: "Booking", subject: "Ana Novak" },
    { carIndex: 6, start: [0, 15, 0], end: [3, 9, 0], status: "Booking", subject: "Nikola B." },
    // Dugotrajni najmovi preko danas
    { carIndex: 2, start: [-15, 8, 0], end: [45, 18, 0], status: "Unajmu", subject: "Long Rent A" },
    { carIndex: 10, start: [-30, 8, 0], end: [60, 18, 0], status: "Unajmu", subject: "Long Rent B" },
    // Ostali događaji za prikaz
    { carIndex: 15, start: [2, 10, 0], end: [5, 10, 0], status: "Booking", subject: "Stan Rez. 1" },
    { carIndex: 16, start: [-5, 9, 0], end: [-1, 18, 0], status: "Gotovo", subject: "Stan Zavrsen" },
    { carIndex: 11, start: [4, 8, 0], end: [4, 17, 0], status: "Service", subject: "Servis bicikl" },
  ];

  return baseEvents.map((event, index) => {
    const startTime = atTime(today, event.start[0], event.start[1], event.start[2]);
    const endTime = atTime(today, event.end[0], event.end[1], event.end[2]);
    const car = cars[event.carIndex];

    return {
      Id: 1000 + index,
      DocumentId: `demo-event-${index + 1}`,
      CarId: car.id,
      IsAllDay: false,
      Subject: event.subject,
      StartTime: startTime,
      EndTime: endTime,
      Location: "Split",
      Description: `Demo rezervacija za ${car.text}`,
      Status: event.status,
      kontaktBroj: "+385 91 000 000",
      brojPonude: `DPO-${1000 + index}`,
      price: "150",
      polog: "100",
      pocetak: "Split",
      kraj: "Split",
      linkRacuna: "nema",
    };
  });
}

export function getDemoData() {
  const cars = createCars();
  const events = createEvents(cars);
  const rentalTypes = [...DEMO_TYPES];
  return { cars, events, rentalTypes };
}

export function getDemoPartners() {
  return [
    { id: 1, ime: "Auto Servis Jurić", djelatnost: "Servis vozila", broj_mobitela: "+385 91 111 111" },
    { id: 2, ime: "Rent Support", djelatnost: "Podrska najmova", broj_mobitela: "+385 91 222 222" },
    { id: 3, ime: "Bike Point", djelatnost: "Servis bicikala", broj_mobitela: "+385 91 333 333" },
    { id: 4, ime: "City Apartments", djelatnost: "Upravljanje smjestajem", broj_mobitela: "+385 91 444 444" },
  ];
}

export function getDemoExternalLinks() {
  return {
    registracijeLink: "https://example.com/registracije-demo",
    servisiLink: "https://example.com/servisi-demo",
  };
}

export function getDemoServiceItems() {
  return [
    { id: 1, naziv: "Mali servis", kategorija: "AUTOMOBIL", status: "Planirano danas" },
    { id: 2, naziv: "Promjena guma", kategorija: "SKUTER", status: "U tijeku" },
    { id: 3, naziv: "Pregled kocnica", kategorija: "BICIKL", status: "Planirano sutra" },
    { id: 4, naziv: "Priprema apartmana", kategorija: "STAN", status: "Zavrseno" },
  ];
}
